import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { EMAIL, MAILTO } from "../site";

export const Contact = () => (
    <section
        id="contact"
        data-testid="contact-section"
        className="relative bg-zinc-950 grain py-24 lg:py-32 overflow-hidden"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl">
                <Reveal>
                    <p className="font-mono-label text-xs font-medium tracking-[0.25em] uppercase text-blue-500 mb-5">
                        Contact
                    </p>
                    <h2
                        data-testid="contact-heading"
                        className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-zinc-50 leading-tight"
                    >
                        Let's Talk
                    </h2>
                </Reveal>
                <Reveal delay={0.12}>
                    <p className="mt-6 text-base sm:text-lg text-zinc-400 leading-relaxed">
                        If you're looking for a professional website for your
                        business, get in touch.
                    </p>
                </Reveal>
                <Reveal delay={0.22}>
                    <div className="mt-10">
                        <a
                            data-testid="contact-email-mailto-button"
                            href={MAILTO}
                            className="group inline-flex items-center gap-2 rounded-full bg-blue-600 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-950"
                        >
                            Email Emira Digital
                            <ArrowUpRight
                                size={17}
                                className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                            />
                        </a>
                        <p
                            data-testid="contact-email-address-text"
                            className="mt-5 font-mono-label text-sm text-zinc-400 tracking-wide"
                        >
                            {EMAIL}
                        </p>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
